import React from 'react';
import { Dashboard } from '../components';

export const Page: React.FC = () => {
  return <Dashboard />;
};
